import { Injectable } from '@angular/core';
import Cookies from 'js-cookie';
import { BehaviorSubject, debounceTime, Subject, takeUntil } from 'rxjs';
import { AVATAR_GRADIENTS, Engagement } from '../models/engagement';
import { environment } from './../../environments/environment';
import { BrowserService } from './browser.service';
import { FirebaseService } from './firebase.service';

@Injectable({
	providedIn: 'root'
})
export class EngagementService {
	unsubscribe = new Subject();
	agencyId!: string;
	engagementId!: string;
	engagement!: Engagement;
	engagement$ = new BehaviorSubject<Engagement | null>(null);
	sourceDomain!: string | null;
	sourceName!: string | null;
	sourceColor!: string | null;
	wordpressHost = environment.wordpressHost;

	constructor(public fire: FirebaseService, public browser: BrowserService) {}

	getSetMotherEngagementInfo(agencyId: string | null, engagementId: string | null) {
		if (agencyId && engagementId) {
			this.agencyId = agencyId;
			this.engagementId = engagementId;

			this.fire
				.getFirestoreDocData(`agencies/${agencyId}/mother_engagements/${engagementId}/public/engagement`)
				.pipe(debounceTime(500), takeUntil(this.unsubscribe))
				.subscribe((e: any) => {
					this.engagement = e as Engagement;
					this.engagement$.next(e);
					this.setEngagementCookie(e);
					console.log(`Engagement: `, e);
				});
		}
	}

	updateMotherEngagementInfo(updateObj: Engagement) {
		if (!this.engagementId && !this.agencyId) return null;

		return this.fire.updateFirestoreDoc(`agencies/${this.agencyId}/mother_engagements/${this.engagementId}`, updateObj);
	}

	private async checkTrackLocation(e: Engagement) {
		if (e && !e.location_tracked) {
			console.log(`Calling Location...`);
			return await this.fire.callableFunction('trackLocation', { agency_id: e.agency_id, engagement_id: e.id });
		}

		return false;
	}

	// async setMomSurvey(surveyId: string) {
	// 	if (surveyId) {
	// 		await this.fire
	// 			.getFirestoreDocData(`onboarding_surveys/${surveyId}`)
	// 			.pipe(takeUntil(this.unsubscribe), debounceTime(500))
	// 			.subscribe((e) => {
	// 				this.survey = e;
	// 				this.survey$.next(e);
	// 				console.log(`ONBOARDING SURVEY: `, e);
	// 				this.surveyId = surveyId;
	// 			});
	// 	}
	// }

	async addMotherEngagement(formValue: any, surveyId: string | null = null, initial_connect_family_id: string | null = null) {
		//TODO will check if agency and if none default to lifeline
		const agency_id = environment.lifelineAgencyId;
		const names = formValue.name.split(' ');

		console.log(`Creating New Engagement for Agency: `, agency_id);

		const mother_avatar_default = this.getRandomAvatarBackground();

		const e: Engagement = {
			mother_first_name: names[0] || null,
			mother_last_name: names[1] || null,
			agency_id,
			mother_phone_formatted: formValue.phone || null,
			mother_phone: this.fire.normalizePhoneNumber(formValue.phone || null),
			mother_avatar_default,
			recommended_article_id: null,
			recommended_article_name: null,
			recommended_article_url: null,
			considering: null,
			counselor_id: null,
			counselor_first_name: null,
			counselor_last_name: null,
			counselor_avatar: null,
			archived: false,
			archived_at: null,
			engagement_deleted: false,
			engagement_deleted_at: null,
			module: 'adoptionAdvocate',
			initial_connect_family_id,
			source_domain: this.sourceDomain || null,
			source_name: this.sourceName || null,
			claimed: false,
			created_at: this.fire.getFirebaseTimestamp()
		};

		if (surveyId) {
			e.onboarding_survey_taken = true;
			e.onboarding_survey_id = surveyId;
		}

		const res = await this.fire.addToFirestoreCollection(`agencies/${agency_id}/mother_engagements`, e).catch((err) => {
			console.log(`Unable to Add engagement.`, err);
			return null;
		});

		if (res) {
			console.log(`RES ID: ${res.id}`);
			this.getSetMotherEngagementInfo(agency_id, res.id);
			// const params = { engagementId: res.id, startQuizId: this.startQuizId || null };
			// this.fire.trackAnalyticsEvent('submitted_contact', params);
			// this.fire.trackPixelEvent('Contact', params);
			// this.fire.trackTikTokEvent('Contact', params);
			return true;
		} else {
			return false;
		}
	}

	setEngagementCookie(cookie: any = null) {
		const domain = this.sourceDomain || environment.cookieDomain || 'family.finder';
		console.log(`Setting Engagement Cookie at domain: `, domain);
		Cookies.set('mlmg_engagement', JSON.stringify(cookie), { expires: 120, domain }); //expires in 120 days
	}

	getEngagementCookieParsed() {
		return JSON.parse(this.getEngagementCookie() || '{}');
	}

	startEngagementFromPhone(phone: any) {
		if (phone) {
			// this.phoneFromUrl = phone;
			// this.phoneFromUrlIsSet$.next(true);
			this.sourceName = 'Lifeline'; //Default to Lifeline
			this.sourceDomain = 'OptionsInAdoption.com'; //Default to Lifeline
			this.sourceColor = 'blue';
			// this.fire.defaultChatAvatar = this.fire.themes['blue'].avatar;
		}
	}

	private getEngagementCookie() {
		const cookie = Cookies.get('mlmg_engagement');
		// console.log(`Cookie Counselor: `, cookie);
		return cookie;
	}

	// setReferralSource(domain: string | null, name: string | null = null, color: string | null = null) {
	// 	this.sourceDomain = domain;
	// 	this.sourceName = name;
	// 	this.sourceColor = color;

	// 	if (color && this.fire.themes[color]) {
	// 		this.fire.defaultChatAvatar = this.fire.themes[color].avatar;
	// 	}
	// }

	getRandomAvatarBackground() {
		const bg = this.fire.shuffle(AVATAR_GRADIENTS)[0];

		const deg = this.fire.randomNumInRange(-360, 360);

		console.log(`RANDOM DEG ${deg}`);

		bg.deg = `${deg}deg`;

		return bg;
	}

	destroySubscriptions() {
		this.unsubscribe.next(null);
		this.unsubscribe.complete();
	}
}
